module.exports = __webpack_public_path__ + "static/media/interactive-image.0a5477b3.svg";